import { client } from './claims';

export interface LoaStats {
  totalActiveClients: number;
  loaSent: number;
  loaSigned: number;
  pending: number;
  neverSent: number;
  sentPercentage: number;
  signedPercentage: number;
}

export interface LoaSenderStatus {
  isEnabled: boolean;
  nextRuns: string[];
  lastRunTime: string | null;
  lastRunResults: {
    sent: number;
    failed: number;
    skipped: number;
    total_eligible: number;
    mailer_error_halted: boolean;
  } | null;
  lastTriggeredBy: string | null;
}

export interface BulkSendResult {
  sent: number;
  failed: number;
  skipped: number;
  total_eligible: number;
  started_at: string;
  completed_at: string;
  triggered_by: string;
  mailer_error_halted: boolean;
  details: Array<{
    clientId: string;
    email: string;
    status: string;
    reason?: string;
    claim_ids: string[];
  }>;
}

export const getLoaStats = () =>
  client.get<LoaStats>('/ui/admin/loa-sender/stats').then(res => res.data);

export const getLoaSenderStatus = () =>
  client.get<LoaSenderStatus>('/ui/admin/loa-sender/status').then(res => res.data);

export const batchSendLoaRequests = (limit?: number) =>
  client.post<BulkSendResult>('/ui/admin/batch-send-loa-requests', { limit }, { timeout: 600000 }).then(res => res.data);

export const enableLoaSender = () =>
  client.post('/ui/admin/loa-sender/enable').then(res => res.data);

export const disableLoaSender = () =>
  client.post('/ui/admin/loa-sender/disable').then(res => res.data);

export const runLoaSenderNow = () =>
  client.post('/ui/admin/loa-sender/run-now').then(res => res.data);
